<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
              <v-flex xs12 class="pb-3">
                <div class="title primary--text">
                  <h4>{{ $t("enrollment.steps.pricing_plan.component.title") }}</h4>
                </div>
              </v-flex>
              <v-flex xs12 mb-3>
                <PricingHandler
                  ref="pricingHandlerForm"
                  :screener="screener"
                  @onSetPricingPlan="setPricingPlan"
                ></PricingHandler>
              </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            dark
            @click.stop="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click.stop="onConfirm"
            >{{ $t("enrollment.steps.continue.button") }}</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script>
import PricingHandler from "@/components/screener/PricingHandler";

export default {
    name:"EnrollmentPricingPlanSelection",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        screener:{
            type: Object,
            default: null
        }
    },
    components:{
        PricingHandler
    },
    methods:{
        setPricingPlan(plan){
            this.$emit("onSetPlan",plan)
        },
        reset(){
            this.$refs.pricingHandlerForm.reset();
        },
        onCancel(){
            this.$emit("onCancel");
        },
        onConfirm(){
            this.$emit("onConfirm");
        },
    }
}
</script>

<style>

</style>
